var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-page"},[_c('div',{staticClass:"video-page__player"},[_c('div',{ref:"jwPlayerContainer",attrs:{"id":_vm.jwPlayerId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }